import SeoLink from '@eversports/klimt-primitives/legacy/SeoLink'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../localization/react'

import { AuthRoutes } from './UserMenu/UserMenu.constants'

interface Props {
  authUrlParams: string
}

// ACCESSIBILITY TODO - Color Contrast
const RegisterButton = ({ authUrlParams }: Props) => (
  <SeoLink
    type="crawler"
    encodedTo={btoa(`${AuthRoutes.REGISTER}${authUrlParams}`)}
    crawlerLink={AuthRoutes.REGISTER}
    external
    buttonVariant="primary"
  >
    <Text variant="small" sx={{ fontWeight: 'bold', color: 'white', textTransform: 'none' }}>
      <Localized id="user-menu-item-register" />
    </Text>
  </SeoLink>
)

export default RegisterButton
